import { ProMigrationPlansView } from 'common/billing/components/ForcedMigration/ProMigrationPlansView'
import { AccountFlag } from 'utils/services/featureFlagsService/constants'

import { paywallExperiments } from '../registry'

/**
 * Forced migration of PRO Flex accounts to the new pricing model: the plan step
 * shows the current plan next to the plan the account is being moved to.
 */
paywallExperiments.register({
  accountFlag: AccountFlag.ENABLE_PRO_V3_MIGRATION,
  views: {
    Plans: ProMigrationPlansView,
  },
})
